import { ref, Ref } from 'vue';
import { ORDER_TYPES } from '@core/order';

import { useLiveSymbolQuery } from '@/modules/symbol';
import { useOrderDialogs } from '@/modules/order';

import { executeOrderEvent } from '@/composables/event/eventBus';
import useRegisterShortcut from '@/composables/shortcut';

export default function useOrderShortcuts(isin: Ref<string>) {
  const shouldExecuteOrder = ref<boolean>(true);

  const { openNewOrderFormDialog } = useOrderDialogs();
  const { symbol } = useLiveSymbolQuery(isin, { immediate: false });

  const orderShortcutActions = [
    {
      execute: (e: KeyboardEvent) =>
        !e.shiftKey ? handleOpenBuyOrderDialog() : null,
      triggerKey: 'keyup' as const,
      shortcutKey: 'F6',
    },
    {
      execute: (e: KeyboardEvent) =>
        !e.shiftKey ? handleOpenSellOrderDialog() : null,
      triggerKey: 'keyup' as const,
      shortcutKey: 'F8',
    },
    {
      execute: (e: KeyboardEvent) => handleExecuteOrder(e),
      triggerKey: 'keydown' as const,
      shortcutKey: 'F10',
    },
  ];

  orderShortcutActions.forEach((actionData) => useRegisterShortcut(actionData));

  const handleOpenBuyOrderDialog = () => {
    openNewOrderFormDialog({
      type: ORDER_TYPES.buy,
      symbol: {
        isin: symbol.value.isin as string,
        instrumentName: symbol.value.instrumentName as string,
        instrumentTypeCode: symbol.value.instrumentTypeCode as string,
      },
    });
  };

  const handleOpenSellOrderDialog = () => {
    openNewOrderFormDialog({
      type: ORDER_TYPES.sell,
      symbol: {
        isin: symbol.value.isin as string,
        instrumentName: symbol.value.instrumentName as string,
        instrumentTypeCode: symbol.value.instrumentTypeCode as string,
      },
    });
  };

  const handleExecuteOrder = (e: KeyboardEvent) => {
    if (shouldExecuteOrder.value) {
      shouldExecuteOrder.value = false;

      setTimeout(() => {
        executeOrderEvent(e.shiftKey);

        shouldExecuteOrder.value = true;
      }, 500);
    }
  };
}
